import { Injectable } from '@angular/core';
import { AssetDto } from '@nusign/picflow-backend-types';

@Injectable({
  providedIn: 'root',
})
export class ExportGalleryService {
  public currentFilteredAssets: AssetDto[];
  public currentSelectedAssets: AssetDto[];
}
